import styled from "styled-components";

import { DATA_E2E_KEY, IStyledAttributes } from "@ryde/shared";
import { MOBILE_BREAKPOINT } from "@ryde/theme";

export const FlexGroupingWrapper = styled.div.attrs<IStyledAttributes>({
  [DATA_E2E_KEY]: "flex-grouping-wrapper",
})`
  display: flex;
  align-items: center;
  flex-direction: row;
  gap: 15px;
  .period-grouping .MuiFormControl-root {
    width: 200px;
  }
  .grouping-params .MuiFormControl-root {
    min-width: 500px;
  }
  @media (max-width: ${MOBILE_BREAKPOINT}) {
    flex-direction: column;

    .period-grouping .MuiFormControl-root {
      width: 100%;
    }
    .grouping-params .MuiFormControl-root {
      min-width: 100%;
    }
  }
`;
